module.exports = __webpack_public_path__ + "img/icon-payment-creditcard.188e9c21.png";